import React, { useMemo, useRef, useState, useEffect } from "react";
import styles from "./DateRangePicker.module.css";
import {
  Button,
  CalendarCell,
  CalendarGrid,
  CalendarGridHeader,
  DateRangePicker,
  CalendarHeaderCell,
  CalendarGridBody,
  Group,
  Heading,
  RangeCalendar
} from "react-aria-components";

import { formatDateRange } from "../../utils/formatDateRange";
import { isDateOutOfRange } from "../../utils/isDateOutOfRange";

export const DateRangePickerWrapper = (props) => {
  const { value, handleDateRangeChange, minValue, maxValue } = props;
  const [isOpen, setIsOpen] = useState(false);
  const dialogRef = useRef(null);

  const onDateChange = (date) => {
    handleDateRangeChange(date);
    setIsOpen(false);
  };

  const selectedLabel = useMemo(() => {
    const startDate = new Date(value.start.year, value.start.month - 1, value.start.day);
    const endDate = new Date(value.end.year, value.end.month - 1, value.end.day);

    return formatDateRange(startDate, endDate);
  }, [value]);

  const toggle = () => {
    setIsOpen((wasOpened) => !wasOpened);
  };

  const isDateUnavailable = (dateData) => {
    return isDateOutOfRange(dateData, minValue, maxValue);
  };

  const checkClose = (e) => {
    if (dialogRef.current && !dialogRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", checkClose);

    return () => document.removeEventListener("click", checkClose);
  }, []);

  return <DateRangePicker
    onChange={onDateChange}
    value={value}
    isDateUnavailable={isDateUnavailable}
    allowsNonContiguousRanges={true}
  >
    <Group>
      <Button className={styles.fieldTrigger} onPress={toggle}>{selectedLabel}</Button>
    </Group>
    {
      isOpen ? <div className={styles.rangeDialog} ref={dialogRef}>
        <RangeCalendar>
          <header className={styles.rangeDialogHeader}>
            <Button className={styles.monthButton} slot="previous">◀</Button>
            <Heading className={styles.monthHeading} />
            <Button className={styles.monthButton} slot="next">▶</Button>
          </header>
          <CalendarGrid className={styles.calendarGrid}>
            <CalendarGridHeader>
              {(day) => (
                <CalendarHeaderCell className={styles.gridHeaderCell}>
                  {day}
                </CalendarHeaderCell>
              )}
            </CalendarGridHeader>
            <CalendarGridBody>
              {(date) => (<CalendarCell className={styles.gridCell} date={date} />)}
            </CalendarGridBody>
          </CalendarGrid>
        </RangeCalendar>
      </div> : null
    }
  </DateRangePicker>
};

export default DateRangePickerWrapper;